export const tiposPessoaEnum = {
   CLIENTE: 0,
   FORNECEDOR: 1,
   TRANSPORTADORA: 2,
   COLABORADOR: 3,
   PRESTADOR: 4,
   PROFISSIONAL: 5
};